<sm-svg-loader *ngIf="loader"></sm-svg-loader>

<div class="dashboard_new" *ngIf="!loader && latestPurchaseData.length == 0">
    <mat-card>
        <div class="upload_sectio">

       <div class="icm_img">
          <img src="./assets/images/s4.png">
       </div>
       <mat-card-title>Check latest purchase and requests</mat-card-title>
       <mat-card-content>Tracking recent purchases helps you maintain optimal inventory levels, preventing both overstock and stock-outs. You can also get insights into which products are in demand.
    </mat-card-content>
       <!-- <div class="watch_vc_btn">
          <button mat-stroked-button color="primary" (click)="openvideo()">
             <mat-icon>smart_display</mat-icon>
             Watch video
          </button>
       </div> -->
    </div>
    </mat-card>
 </div>

 <!-- with data -->

 <div class="today_booking_card" *ngIf="!loader && latestPurchaseData.length > 0">
    <mat-card>
    <div class="vier_tht">
       <div class="heading_ot">
       <h3>Latest purchase</h3> 
      </div>
       <div class="view_all_btn" *ngIf="latestPurchaseData[0].total_count > 4">
        <a (click)="viewAll()">{{latestPurchaseData[0].total_count > 4 ? 'View all ' + latestPurchaseData[0].total_count : 'View details'}}</a>
      </div>
  </div>
  <!--  -->
  <div class="list_yy" *ngFor="let item of latestPurchaseData">
    <div class="bookign_img">
        <!-- <div class="status_yl"></div> -->
       <img [src]="item.image_thumb_url" onerror="this.src='../../../../../../assets/images/salon_support_header.png'" alt=""/>
    </div>
    <div class="booking_heading">
        <h3>{{item.item_name}}</h3>
        <p>{{item.purchase_quantity}} {{item.purchase_unit}}</p>
    </div>
    <div class="booking_heading">
        <h3>{{item.name}}</h3>
        <p>{{item.address_line}}</p>
    </div>
    <div class="booking_heading">
        <h3 *ngIf="item.purchase_date">{{item.purchase_date | date}}</h3>
        <p *ngIf="item.purchase_date">{{item.purchase_date | date : 'h:mm a':'UTC'}}</p>
        <h3 *ngIf="!item.purchase_date" style="color: #FFC107;">Reminder</h3>
        <!-- <p>3:00 PM</p> -->
    </div>
    <div class="booking_heading">
        <h3>{{item.purchase_quantity}} {{item.purchase_unit}}</h3>
        <p>{{item.currency_symbol}}{{item.purchase_price.toFixed(2)}}</p>
    </div>
  </div>
  <div class="list_yy" style="height: 61px;" *ngFor="let item of repeatArray">
    
  </div>

 
</mat-card>

</div>